(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dvb-category-branch"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-dvb-branch-toggle]');
  if (!button) return;
  var list = document.getElementById(button.getAttribute('aria-controls'));
  if (!list) return;
  event.preventDefault();
  event.stopPropagation();
  var open = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', open ? 'false' : 'true');
  list.hidden = open;
});
  } catch(e) { console.error(e); }
})();

})();
